import { render, staticRenderFns } from "./LedgerTransactions.vue?vue&type=template&id=06e6fde7&scoped=true"
import script from "./LedgerTransactions.vue?vue&type=script&lang=js"
export * from "./LedgerTransactions.vue?vue&type=script&lang=js"
import style0 from "./LedgerTransactions.vue?vue&type=style&index=0&id=06e6fde7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6fde7",
  null
  
)

export default component.exports